// The backend returns user-facing messages as ready-made Finnish strings
// instead of codes (see membership-register-backend
// server/services/authentication/index.js). Until the backend can return
// codes, map the known strings to translation keys here.
//
// toMessageKey() returns the matching key for a known backend string, or
// the input unchanged otherwise. Views render messages through t(), which
// passes unknown/raw strings through verbatim, so unmapped messages keep
// working (displayed in Finnish) instead of breaking.
const serverMessageMap = {
    'Syötä sähköpostiosoite.': 'server.emailEmpty',
    'Syötä sähköpostiosoite ja salasana.':
        'server.emailOrPasswordEmpty',
    'Salasana päivitetty onnistuneesti.': 'server.passwordUpdated',
    'Sähköpostiosoite on jo käytössä.': 'server.emailInUse',
    'Väärä sähköposti tai salasana.': 'server.wrongCredentials',
    'Käyttäjä luotu onnistuneesti.': 'server.memberAdded',
    'Kaikki kentät ovat pakollisia.': 'server.allFieldsRequired',
    'Jossakin kentässä on vikaa.': 'server.fieldInvalid',
    'Sähköpostiosoitteen ja UTU-tunnuksen oltava uniikkeja.':
        'server.emailOrUtuNotUnique',
    'Salasanat eivät täsmää.': 'server.passwordsMismatch',
    'Käyttäjätunnus luotu onnistuneesti.': 'server.userAccountCreated',
    'Ongelma palautuksessa.': 'server.resetFailed',
    'Salasanan palautuslinkki lähetetty jos sellainen sähköpostiosoite löytyi järjestelmästä.':
        'server.resetLinkSent',
    'Sähköpostin lähetys epäonnistui.': 'server.mailFailed',
    'Linkki vanhentunut.': 'server.linkExpired',
    'Salasanan minimipituus on 6 merkkiä.': 'server.passwordTooShort',
    'Jotain meni vikaan.': 'server.somethingWentWrong',
    // Member service (server/services/member/index.js)
    'Tiedot päivitetty onnistuneesti.': 'server.detailsUpdated',
    'Kaikki paitsi salasanakentät ovat pakollisia.':
        'server.allButPasswordsRequired',
    'Asiakas ei ole admin.': 'server.clientNotAdmin',
    'Tämä alue vain vain hallituslaisille.': 'server.boardOnly',
    // Admin service (server/services/admin/index.js)
    'Jäsen poistettu.': 'server.memberRemoved',
    'Tiedot päivitetty onnistuneesti. Päivitä sivu nähdäksesi muutokset':
        'server.detailsUpdatedRefresh',
    'Salasanat ei täsmää.': 'server.passwordsMismatchAdmin',
    'Tämä alue on vain hallituslaisille.': 'server.boardOnlyAdmin',
    'Uusi jäsen lisätty onnistuneesti.': 'server.memberAddedNew',
};

const toMessageKey = (message) => serverMessageMap[message] || message;

module.exports = { toMessageKey };
